<div class="container_dialog">
    <div class="header_popup header_popup_center">
      <div class="title_popup title_popup_center">
          <span>{{"companies.documents_Files"|translate}}</span>
      </div>
      <button (click)="closed()">
          <mat-icon style="color: black;">close</mat-icon>
      </button>
    </div>
    <div class="content_dialog">
        <app-files-previewer
            [data]="data"
            [isNotExport]="true"
        >
        </app-files-previewer>
    </div>
</div>